'use strict';

/* global $ */

/**
 * Обработчик для установки целей для систем аналитики

 * Пример вызова
 *  Цели устанавливаются в главном скрипте, который запускает всю оболочку.

    Targets.init([
                    {
                        selector: "a", // jQuery-селектор для объекта
                        child: "", // jQuery-селектор для объекта потомка (опционально)
                        method: 'click', // метод, по которому будет вызвано событие
                        immediate: true, // способ повесить цель:
                                         // true - цель будет повещена сразу же при инициализации объекта. Если объект по селектору не найден, то цель не будет установлена
                                         // false - цель не будет вовешена сразу, но будет в списке целей и ее можно будет установить вручную через метод set
                        fn: function(){  // callback на срабатывание цели
                            yaCounter29879444.reachGoal('order-click');
                        }
                    }
                ]);
    Targets.set("имя_метода"). Важно, чтобы устанавливаемая цель имела уникальное название метода, либо будут заново установлены все цели по данному методу
    Для вызова цели достаточно на нужном объекте вызвать .trigger("имя_метода");
 */

let targets = [];

function _process_targets(){
    for (let i = 0; i < targets.length; i++) {
        if(targets[i].immediate){
            _set_action(i);
        }
    }
}

function _set_action(idx){
    if((targets[idx].child) && (targets[idx].child !== '')){
        $(targets[idx].selector).on(targets[idx].method, targets[idx].child, targets[idx].fn);
    }else{
        $(targets[idx].selector).on(targets[idx].method, targets[idx].fn);
    }
}

function init(data){
    if(data){
        targets = data;
        _process_targets();
    }
}

function set(method){
    for (var i = 0; i < targets.length; i++) {
        if(targets[i].method == method){
            _set_action(i);
        }
    }
}

export { init, set };
